//Hamburger Navigation
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.getElementById('menu-toggle');
  const menuItems = document.getElementById('menu-items');
  const menuLinks = document.querySelectorAll('#menu-items a'); // Alle Links im Menü auswählen

  if (menuToggle && menuItems) {
    menuToggle.addEventListener('click', function() {
      menuItems.classList.toggle('active');
      // console.log('Menu toggled'); // Debugging-Ausgabe
    });

    // Event Listener für jeden Link im Menü hinzufügen
    menuLinks.forEach(link => {
      link.addEventListener('click', function() {
        menuItems.classList.remove('active');
        // console.log('Menu closed after link click'); // Debugging-Ausgabe
      });
    });


  } else {
    // console.error('Menu elements not found'); // Fehlerausgabe
  }
});
